import React, { useState } from "react";
import Warranty from "./Warranty";
import PendingWarrantyList from "./pendingwarranty";
import ApprovedWarrantyList from "./approvedwarranty";
import WarrantyClimeList from "./WarrantyClimeList";
import RejectedWarrantyList from "./rejectedwarrantylist";
// import PendingWarranty from "./pending-warranty";
// import ApprovedWarranty from "./approved-warranty";
// import RejectedWarranty from "./rejected-warranty";

const Warrantytab = () => {
  const [activeTab, setActiveTab] = useState("Hologram Issue");

  return (
    <div style={styles.wrapper}>
      {/* Tabs */}
      <div style={styles.tabs}>
        {["Hologram Issue","Pending", "Approved", "Rejected","Warranty Claim List"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              ...styles.tabBtn,
              borderBottom:
                activeTab === tab ? "2px solid #005487" : "none",
              color: activeTab === tab ? "#005487" : "#333",
            }}
          >
            {tab}
          </button>                                                                                                                                                                                                                               
        ))}
      </div>

      {/* Tab Content */}  

        
        {activeTab === "Hologram Issue" && <Warranty/>}
      {activeTab === "Pending" && <PendingWarrantyList/>}

      {activeTab === "Approved" &&<ApprovedWarrantyList/>}

      {activeTab === "Rejected" && <RejectedWarrantyList/>}
    </div>
  );
};

export default Warrantytab;

const styles = {
  wrapper: {
    background: "#fff",
    padding: "15px",
    borderRadius: "6px",
  },

  tabs: {
    display: "flex",
    borderBottom: "1px solid #ddd",
    marginBottom: "15px",
  },

  tabBtn: {
    background: "none",
    border: "none",
    padding: "10px 16px",
    cursor: "pointer",
    fontWeight: 500,
  },
};